import { Wrapper, Image, Name } from './Styled'

interface ListItemProps {
  name?: string
  imageUrl?: string
  autoWidth?: any
  avatarWidth?: any
  avatarHeight?: any
}

/** 元件 - 片商 */
export default function ListItem({ name, imageUrl, autoWidth, avatarWidth, avatarHeight }: ListItemProps) {
  return (
    <Wrapper>
      <Image src={imageUrl} source="preview" />

      <Name>{name}</Name>
    </Wrapper>
  )
}
